import { createContext, useContext, useEffect, useState } from "react";

type EnvContextType = {
  selectedOrg: string | null;
  setSelectedOrg: (org: string) => void;
  selectedEnv: string | null;
  setSelectedEnv: (env: string) => void;
};

const EnvContext = createContext<EnvContextType | undefined>(undefined);

export const EnvProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedOrg, setSelectedOrgState] = useState<string | null>(null);
  const [selectedEnv, setSelectedEnvState] = useState<string | null>(null);

  useEffect(() => {
    setSelectedOrgState(localStorage.getItem("selectedOrg"));
    setSelectedEnvState(localStorage.getItem("selectedEnv"));
  }, []);

  const setSelectedOrg = (org: string) => {
    localStorage.setItem("selectedOrg", org);
    setSelectedOrgState(org);
  };

  const setSelectedEnv = (env: string) => {
    localStorage.setItem("selectedEnv", env);
    setSelectedEnvState(env);
  };

  return (
    <EnvContext.Provider value={{ selectedOrg, setSelectedOrg, selectedEnv, setSelectedEnv }}>
      {children}
    </EnvContext.Provider>
  );
};

export const useEnv = () => {
  const context = useContext(EnvContext);
  if (!context) throw new Error("useEnv must be used within EnvProvider");
  return context;
};
